// @flow
import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Dialog from '@material-ui/core/Dialog';
import PropTypes from 'prop-types';
import IconButton from '@material-ui/core/IconButton';
import Icon from '@material-ui/core/Icon';
import DialogContent from '@material-ui/core/DialogContent';

import Rating from '../../components/rating/Rating';

const useStyles = makeStyles((theme) => ({
	closeBtn: {
		width: 30,
		padding: 0,
		'& .MuiIcon-root': {
			width: 30,
			height: 30,
			fontSize: 20,
			lineHeight: '30px',
		},
	},
	content: {
		padding: '0 20px 28px',
	},
	dialog: {
		width: '95%',
		margin: 0,
    '@media screen and (max-width: 664px)': {
      maxWidth: 'unset !important', 
    }
	},
}));

type Props = {|
	open: boolean,
	closeDialog: (boolean) => void,
	submitRating: (Object) => void,
|};

export default function RatingDlg({ open, closeDialog, submitRating }: Props) {
	const classes = useStyles();

	return (
		<Dialog
			maxWidth='sm'
			open={open}
			aria-label='rating dialog'
			fullWidth={true}
			scroll='body'
			classes={{ paperScrollBody: classes.dialog }}
		>
			<IconButton aria-label='close' className={classes.closeBtn} onClick={() => closeDialog(true)}>
				<Icon>close</Icon>
			</IconButton>
			<DialogContent classes={{ root: classes.content }}>
				<Rating onSubmit={submitRating} />
			</DialogContent>
		</Dialog>
	);
}

RatingDlg.propTypes = {
	open: PropTypes.bool.isRequired,
	closeDialog: PropTypes.func.isRequired,
	submitRating: PropTypes.func.isRequired,
};
